const useHandleCourseStatus = (courseUpdate, sendToCourses) => async (courseId, isCurrentlyDraft) => {
  const response = await courseUpdate(courseId, isCurrentlyDraft);
  sendToCourses(response);
};

export default useHandleCourseStatus;
